/*
 * $Id:: index.js 2021/02/24 05:35 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

let loginUrl;
let logoutUrl;

export const setLoginUrl = (url) => {
    loginUrl = url;
};

export const getLoginUrl = () => loginUrl;

export const setLogoutUrl = (url) => {
    logoutUrl = url;
};

export const getLogoutUrl = () => logoutUrl;
